import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h2 className="text-4xl font-medium text-gray-900 mb-6">
              About Curiye Advert
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We are a creative agency that specializes in visual storytelling, brand identity, and event branding. 
              We offer strategic design solutions for businesses, organizations, and startups that want to build 
              strong, clear, and memorable brands.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our team combines creativity with strategy to deliver exceptional results that not only look great 
              but also drive business growth and create lasting connections with your audience.
            </p>
            <button className="btn-primary">
              Start Your Project
            </button>
          </div>
          <div className="relative">
            <div className="w-full h-96 rounded-2xl overflow-hidden shadow-lg">
              <img 
                src="/images/about us.jpg" 
                alt="About Curiye Advert - Our team working together" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;
